export const STATS = {
  SHELL: {},
  ADMIN: {},
  MAP: {
    CREATE: "map_create",
    OPEN: "map_open",
    IMPORT: "map_import",
    NODE_CREATE: "map_node_create",
    EDGE_CREATE: "map_edge_create",
    TABLE_CREATE: "map_table_create",
    IMAGE_INSERT: "map_image_insert",
    VIDEO_INSERT: "map_video_insert",
    LINK_INSERT: "map_link_insert",
    DOCUMENT: "map_document",
    PRINT: "map_print",
    SHARE_INTERNAL: "map_share_internal",
    SHARE_CLASSROOM: "map_share_classroom",
    SHARED_VIEW: "map_shared_view",
    SHARED_COPY: "map_shared_copy",
    SHOW: "map_show",
  },
  EDITOR: {
    CREATE: "edt_create",
    OPEN: "edt_open",
    IMPORT: "edt_import",
    PRINT: "edt_print",
    SHARE_INTERNAL: "edt_share_internal",
    SHARE_CLASSROOM: "edt_share_classroom",
    SHARED_VIEW: "edt_shared_view",
    SHARED_COPY: "edt_shared_copy",
    EXPORT_PDF: "edt_export_pdf",
  },
  PDF: {
    OPEN: "pdf_open",
    IMPORT: "pdf_import",
    PRINT: "pdf_print",
    SHARE_INTERNAL: "pdf_share_internal",
    SHARE_CLASSROOM: "pdf_share_classroom",
    SHARED_VIEW: "pdf_shared_view",
    SHARED_COPY: "pdf_shared_copy",
  },
  MATH: {
    OCR: "mth_ocr",
    INSERT_IN_DOC: "mth_insert_in_doc",
    OCR_IN_EDITOR: "mth_ocr_in_editor",
    AI_CHECK: "mth_ai_check",
  },
  INTERACTION: {
    MAP_MAP_COPY_PASTE: "map_map_copy_paste",
    MAP_MAP_COPY_DEEP: "map_map_copy_deep",
    MAP_MAP_CROP_PASTE: "map_map_crop_paste",
    MAP_MAP_MAP_IMAGE_PASTE: "map_map_map_image_paste",
    //
    MAP_EDITOR_COPY_PASTE: "map_editor_copy_paste",
    MAP_EDITOR_COPY_DEEP: "map_editor_copy_deep",
    MAP_EDITOR_CROP_PASTE: "map_editor_crop_paste",
    MAP_EDITOR_MAP_IMAGE_PASTE: "map_editor_map_image_paste",
    //
    MAP_PDF_COPY_PASTE: "map_pdf_copy_paste",
    MAP_PDF_COPY_DEEP: "map_pdf_copy_deep",
    MAP_PDF_CROP_PASTE: "map_pdf_crop_paste",
    MAP_PDF_MAP_IMAGE_PASTE: "map_pdf_map_image_paste",
    //
    EDITOR_MAP_COPY_PASTE: "editor_map_copy_paste",
    EDITOR_MAP_COPY_DEEP: "editor_map_copy_deep",
    EDITOR_MAP_CROP_PASTE: "editor_map_crop_paste",
    //
    EDITOR_EDITOR_COPY_PASTE: "editor_editor_copy_paste",
    EDITOR_EDITOR_COPY_DEEP: "editor_editor_copy_deep",
    EDITOR_EDITOR_CROP_PASTE: "editor_editor_crop_paste",
    //
    EDITOR_PDF_COPY_PASTE: "editor_pdf_copy_paste",
    EDITOR_PDF_COPY_DEEP: "editor_pdf_copy_deep",
    EDITOR_PDF_CROP_PASTE: "editor_pdf_crop_paste",
    //
    PDF_MAP_COPY_PASTE: "pdf_map_copy_paste",
    PDF_MAP_COPY_DEEP: "pdf_map_copy_deep",
    PDF_MAP_CROP_PASTE: "editor_pdf_crop_paste",
    //
    PDF_EDITOR_COPY_PASTE: "pdf_editor_copy_paste",
    PDF_EDITOR_COPY_DEEP: "pdf_editor_copy_deep",
    PDF_EDITOR_CROP_PASTE: "pdf_editor_crop_paste",
    //
    PDF_PDF_COPY_PASTE: "pdf_pdf_copy_paste",
    PDF_PDF_COPY_DEEP: "pdf_pdf_copy_deep",
    PDF_PDF_CROP_PASTE: "pdf_pdf_crop_paste",
  },
};

export const QUERIES = {
  STATS_ADMIN_PERIOD: "stats_admin_period",
};
